import WpPage from '../wp_page';
import wpPageStateManager from '../wp_page_state_manager';

export default function(store) {
  return {
    path: '/terms-and-conditions',
    component: WpPage,
    exact: true,
    strict: true,
    loadData: wpPageStateManager(store)
  };
}



// WEBPACK FOOTER //
// ./src/views/containers/pages/wp_page/routes/terms_route.js